<mat-form-field appearance="outline">
  @if (!hideLabel) {
    <mat-label>{{ label }}</mat-label>
  }
  @if (inputType === 'textarea') {
    <textarea
      matInput
      [formControl]="getFormControl()"
      [id]="key"
      [type]="inputType"
      rows="{{textAreaInitialRowCount}}"
      (ngModelChange)="modelChange.emit($event)"
      [required]="required"
    ></textarea>
  } @else if (matAutocomplete) {
    <input
      #input
      (ngModelChange)="modelChange.emit($event)"
      matInput
      [formControl]="getFormControl()"
      [id]="key"
      [type]="inputType === 'number' ? 'text' : inputType"
      [required]="required"
      [step]="step"
      [matAutocomplete]="matAutocomplete"
    >
  } @else {
    <input
      #input
      (ngModelChange)="modelChange.emit($event)"
      matInput
      [formControl]="getFormControl()"
      [id]="key"
      [type]="inputType === 'number' ? 'text' : inputType"
      [required]="required"
      [step]="step"
    >
  }

  <mat-error>
    <ng-container *ngFor="let error of this.getErrorMessage()">{{ error }}<br></ng-container>
  </mat-error>
</mat-form-field>
